<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="备注：" class="query-form-item">
                <el-input placeholder="请输入备注" v-model="filter.remark" clearable style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="add">导入评论地址</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            border
            class="table_content"
            style="width: 100%">
            <el-table-column
                label="监控评价链接"
                min-width="300"
                align="center">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="点击跳转链接地址" placement="top-start">
                    <span style="cursor: pointer;" @click="tolink(scope.row)">{{ scope.row.link }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                min-width="150"
                align="center"
                label="备注">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.remark == null || scope.row.remark == ''" class="item" effect="dark" content="点击添加备注" placement="top-start">
                        <div @click="addremark(scope.row, '添加备注')" style="cursor: pointer;">暂无备注</div>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" content="修改备注" placement="top-start">
                        <div @click="addremark(scope.row, '修改备注')" style="cursor: pointer;">{{ scope.row.remark }}</div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                width="80"
                align="center"
                label="是否掉评">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.review_failure == 0" type="info">未爬取</el-tag>
                    <el-tag v-else-if="scope.row.review_failure == 1" type="danger">已掉评</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                width="80"
                align="center"
                label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="deleteEvaluation(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            :current-page="query.page"
            :page-size="query.limit"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total"
            style="float: right;margin-top: 20px; margin-bottom: 12px"
            background>
        </el-pagination>
        <add :visible="ctrl.addDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"  @error-dialog="errorDialog"></add>
        <error-page :visible="ctrl.errorVisible" :list="listData" @close-callback="closeCllback"></error-page>
        <onremark :visible="ctrl.onremarkDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></onremark>
    </div>
</template>

<script>
import * as api from "@/api/evaluation/evaluation";
import Add from "./add";
import ErrorPage from "./errorPage";
import Onremark from "./onremark";
export default {
    components: { Add, ErrorPage, Onremark },
    data() {
        return {
            list: [],
            ctrl: {
                addDialogVisible: false,
                errorVisible: false,
                onremarkDialogVisible: false
            },
            filter: {},
            query: {
                page: 1,
                limit: 20
            },
            formData: {},
            listData: [],
            loading: false
        };
    },
    methods: {
        getList() {
            let obj = this.query;
            obj.filter = this.filter;
            this.loading = true;
            api.not_aggregate_page_list(obj)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //筛选
        add() {
            this.ctrl.addDialogVisible = true;
            this.ctrl.dialogTitle = "添加评价监控";
        },
        //错误内容
        errorPageDialog() {
            this.ctrl.errorVisible = true;
        },
        //错误页面
        errorDialog(data) {
            let that = this;
            this.listData = data.data;
            setTimeout(function() {
                that.errorPageDialog();
            }, 10);
        },
        //添加备注
        addremark(data, str) {
            this.formData = data;
            this.ctrl.onremarkDialogVisible = true;
            this.ctrl.dialogTitle = str;
        },
        //删除评价监控
        deleteEvaluation(data) {
            this.$confirm(`确定要删除这个评价监控吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.remove({ id: data.id }).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                type: "success",
                                message: "删除评价监控成功"
                            });
                            this.getList();
                            this.$emit("close-list", this.datasrow);
                        } else {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getList();
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 20,
                total: 0
            };
            this.filter = {};
            this.getList();
        },
        //跳转到评论链接页面
        tolink(data) {
            window.open(data.link, "_blank");
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.addDialogVisible = false;
            this.ctrl.errorVisible = false;
            this.ctrl.onremarkDialogVisible = false;
            if (isshow) return;
            this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.table_content {
    height: calc(100vh - 260px);
    overflow: auto;
    border: 1px solid #ebeef5;
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
.el-tooltip__popper {
    max-width: 300px !important;
}
.pen {
    cursor: pointer;
}
</style>
